import * as React from "react";
import Component from "../../AbstractComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import Button from '@material-ui/core/Button';

export default class PersonDetailsReadonly extends Component {
	public state = {
		
	};

  constructor(public props) {
    super(props);
	}

	public getReadonlyReason = (person: PersonInterface) => {
		if (person?.removed) {
			return this.trans("person-readonly/removed");
		}
	}
	
  public render() {
		const person: PersonInterface = this.props.person;
		
		return (
			<div className="charge-details-readonly">
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-start"}}>
					<div style={{marginRight: "7px", fontSize: "17px", fontWeight: "bold"}}>
						{this.props.user ? this.trans("label-user") : this.trans("label-person")}
					</div>
				</div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "baseline"}}>
					<div className="counterparty">
						{`${person?.displayName}`}
					</div>
				</div>
				<table>
					{
						person?.email && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label-email")}: `}
								</td>
								<td className="align-left">
									{person?.email}
								</td>
							</tr>
						)
					}
					{
						person?.company && (
							<tr>
									<td className="align-left first-column">
										{`${this.trans("label-company")}: `}
									</td>
									<td className="align-left">
										<div className="margin-wrapper">
											<div 
												className="link-to-entity" 
												onClick={() => this.redirect(`/app/company/update/${person?.companyId}/`)}
											>
												{`${person?.company?.displayName}`}
											</div>
										</div>
									</td>
								</tr>
						)
					}
					{
						person?.phone1 && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("label-mob-number")}: `}
								</td>
								<td className="align-left">
									{person?.phone1}
								</td>
							</tr>
						)
					}
					{
						person?.phone2 && (
							<tr>
								<td className="align-left first-column">
									{`${this.trans("other-phone")}: `}
								</td>
								<td className="align-left">
									{person?.phone2}
								</td>
							</tr>
						)
					}
				</table>
				{
					person?.isReadonly && this.props.mainCardPresentation &&
						<div className="readonly-reason" style={{flexDirection: "column"}}>
							<div style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
								<div
									className="list-label readonly"
									style={{
										marginRight: "5px",
										maxWidth: "max-content"
									}}
								>
									{person?.isReadonly && this.trans("label-readonly")}
								</div>
								<div>{this.getReadonlyReason(person)}</div>
							</div>
						</div>
				}
				{
					!this.props.mainCardPresentation && (
						<div style={{marginTop: "10px", display: "flex", justifyContent: "space-between"}}>
							<Button 
								variant="outlined"
								color="primary"
								onClick={() => this.redirect(`/app/person/update/${person?.id}`)}
							>
								{this.trans("button-open")}
							</Button>
							<Button 
								variant="outlined"
								style={{color: "#F44336", borderColor: "#F44336"}}
								onClick={() => {
									if (this.props.removePerson) {
										this.props.removePerson.call(this, person)
									}
								}}
							>
								{this.trans("button-remove")}
							</Button>
						</div>
					)
				}
			</div>
		);
  }
}
